<template>
  <div>
    <chip-component class="mb-1" v-for="(status, index) in getStatus" :reason="getReason" :key="index" :payload="status" :add-class="[]"/>
  </div>
</template>

<script>
import ChipComponent from '@/arch/components/ChipComponent.vue'
import mixinOrderStatus from '@/mixins/mixinOrderStatus'

export default {
  name: 'DataTableChipStatus',
  components: { ChipComponent },
  mixins: [mixinOrderStatus],
  props: {
    value: {
      type: [String, Object, Array],
      default: null,
    },
    row: {
      type: [Object],
      default: null
    },
    options: {
      type: Object,
      default() {
        return {
          // eslint-disable-next-line no-unused-vars
          transform: (value, row) => value,
        }
      },
    },
  },
  computed: {
    getStatus() {
      if( !this.value ) {
        return []
      }

      let keys
      let payload = this.value

      if (typeof payload != 'object') { 
        payload = { [this.value] : null}
      }
      keys = Object.keys(payload)

      let status = [] 

      keys.forEach((key) => {
        let chip = this.getNewStatus(this.options.transform(key))
        if( chip ){
          chip.label = `${chip.label}` + (payload[key] ? `: ${ payload[key]}` : '') 
        } else {
          console.warn(`Order status  "${this.options.transform(key).toUpperCase()}" not found, showing label "${this.row.TYPE_DESCRIPTION}" by field TYPE_DESCRIPTION`)
          chip = {
            color: 'grey darken-1',
            textColor: 'white',
            label: `${this.row.TYPE_DESCRIPTION}: ${payload[key]}`,
          }
        }

        status.push(chip)
      })

      return status
    },
    getReason() {
      if(!this.row){
        return ''
      }
      if(this.row.HOLD_NAME){
        let names = this.row.HOLD_NAME.split(',');
        var holdName = "<ol>";
        names.forEach(name => {
          holdName = holdName + '<li>'+name+'</li>'
        });
        holdName = holdName + "</ol>";
        return holdName;
      }
      return false;
    }
  },
}
</script>
